// 1. 核心：导入 Vue 和 Vuex（必须加！）
import Vue from 'vue'
import Vuex from 'vuex'

// 2. 安装 Vuex 插件（Vue2 必须，让 Vue 识别 Vuex）
Vue.use(Vuex)

// 3. 导入你的各个功能模块（原有代码保留）
import login from './modules/login'
import breadcrumb from './modules/breadcrumb'
import project from './modules/project'
import jurisdiction from './modules/jurisdiction'
import cookies from './modules/cookies'

const debug = process.env.NODE_ENV !== 'production';

// 4. 创建并导出 Store 实例（原有代码保留）
export default new Vuex.Store({
  modules: {
    login,
    breadcrumb,
    project,
    jurisdiction,
    cookies,
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/comm/store/store.js